import {Component} from "react";
import {monthNames, countWordaysForWithWorkdays} from "../../lib/date-utils";
import {cx, XCol, XText} from "@cdx/common";
import {milestoneBannerStyles as styles} from "./deck.css";
import {msColorThemes} from "../../pages/milestones/milestone-theme.css";

export default class MilestoneBanner extends Component {
  state = {isOverMSBanner: false};

  handleMouseEnterMSBanner = () => {
    if (this.mouseLeaveTimoutId) clearTimeout(this.mouseLeaveTimoutId);
    this.setState({isOverMSBanner: true});
  };

  handleMouseLeaveMSBanner = () => {
    this.mouseLeaveTimoutId = setTimeout(() => {
      clearTimeout(this.mouseLeaveTimoutId);
      this.setState({isOverMSBanner: false});
    }, 750);
  };

  render() {
    const {isOverMSBanner} = this.state;
    const {milestoneDate: _rawDate, milestoneColor, workdays} = this.props;
    if (!_rawDate || !milestoneColor) return null;

    const {day, month, year} = _rawDate;

    const milestoneDate = new Date(year, month - 1, day);
    const todayMidnight = new Date(new Date().setHours(0, 0, 0, 0));
    const daysLeft = Math.round(
      (milestoneDate.getTime() - todayMidnight.getTime()) / (24 * 3600 * 1000)
    );
    const workdaysLeft = countWordaysForWithWorkdays({
      workdays,
      todayMidnight,
      targetDay: milestoneDate,
    });
    let first = null;
    let second = null;
    if (daysLeft <= 30) {
      first = workdaysLeft;
      second = workdaysLeft === 1 ? "day" : "days";
    } else if (daysLeft <= 180) {
      first = day;
      second = (monthNames[month - 1] || "").slice(0, 3);
    } else {
      first = (monthNames[month - 1] || "").slice(0, 3);
      second = year;
    }
    const isShown = isOverMSBanner || (daysLeft <= 30 && daysLeft >= -7);
    const theme = msColorThemes[milestoneColor] || msColorThemes.blue;

    return (
      <XCol absolute noOverflow inset="x" style={{top: -2}} pb={0} align="center">
        <XCol
          elevation={2}
          px={1}
          py={0}
          className={cx(theme, styles.banner.base, isShown && styles.banner.shown)}
          onMouseEnter={this.handleMouseEnterMSBanner}
          onMouseLeave={this.handleMouseLeaveMSBanner}
        >
          <div className={cx(styles.content.base, isShown && styles.content.shown)}>
            <XText preset="bold" align="center" color="white">
              {first}
            </XText>
            <XText align="center" color={null} size={0}>
              {second}
            </XText>
          </div>
        </XCol>
      </XCol>
    );
  }
}
